import type { Pagination } from '@aigc/types';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { parsePaginationSearch } from '../../../features/common/pagination-search';
import { Permission } from '../../../features/common/permision';
import { ScriptHistory } from '../../../features/statistics/components/script-history';

const ScriptPage = () => {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const handlePaginationChange = (pagination: Pagination) => {
    navigate({
      replace: true,
      search: {
        page: pagination.page ?? 1,
        pageSize: pagination.size ?? 10,
      },
    });
  };

  return (
    <ScriptHistory
      defaultPagination={{ page: search?.page, size: search?.pageSize }}
      onPaginationChange={handlePaginationChange}
    />
  );
};

export const Route = createFileRoute('/_creator-center/video/script')({
  staticData: { permissions: [Permission.视频生成] },
  validateSearch: parsePaginationSearch,
  component: ScriptPage,
});
